import React from "react";
import "../styles/InfoPanels.css";

export default function AboutPanel() {
  const buildYear = new Date().getFullYear();

  return (
    <div className="info-panel">
      <div className="info-panel__mesh" aria-hidden />

      <header className="info-panel__header">
        <p className="info-panel__eyebrow">Application</p>
        <h2 className="info-panel__title">About Girinestham</h2>
        <p className="info-panel__sub">
          A comprehensive workspace management platform.
        </p>
      </header>

      <section className="info-panel__section">
        <h3 className="info-panel__section-title">What is Girinestham?</h3>
        <p className="info-panel__body-text">
          Girinestham is an all-in-one organizational management platform built to streamline
          day-to-day operations. It provides powerful modules for attendance tracking with face
          verification and geofencing, user and role management, property asset tracking,
          certificate generation, maintenance workflows, and more.
        </p>
      </section>

      <section className="info-panel__section">
        <h3 className="info-panel__section-title">Key Features</h3>
        <div className="info-panel__feature-grid">
          {[
            { icon: "📷", label: "Face-verified attendance" },
            { icon: "📍", label: "Geofencing support" },
            { icon: "👥", label: "User & role management" },
            { icon: "🏠", label: "Property asset tracking" },
            { icon: "📜", label: "Certificate generation" },
            { icon: "🔧", label: "Maintenance workflows" },
            { icon: "☁", label: "Multi-cloud storage (Local, Supabase, S3)" },
            { icon: "🖼", label: "WebP image optimization" },
          ].map((f) => (
            <div key={f.label} className="info-panel__feature-item">
              <span className="info-panel__feature-icon">{f.icon}</span>
              <span>{f.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="info-panel__section">
        <h3 className="info-panel__section-title">Technical Details</h3>
        <div className="info-panel__detail-grid">
          <div className="info-panel__detail-row">
            <span className="info-panel__detail-key">Frontend</span>
            <span className="info-panel__detail-val">React</span>
          </div>
          <div className="info-panel__detail-row">
            <span className="info-panel__detail-key">Backend</span>
            <span className="info-panel__detail-val">Node.js / Express</span>
          </div>
          <div className="info-panel__detail-row">
            <span className="info-panel__detail-key">Database</span>
            <span className="info-panel__detail-val">MySQL</span>
          </div>
          <div className="info-panel__detail-row">
            <span className="info-panel__detail-key">Storage</span>
            <span className="info-panel__detail-val">Local / Supabase / AWS S3</span>
          </div>
        </div>
      </section>

      <footer className="info-panel__footer">
        <p>&copy; {buildYear} Girinestham. All rights reserved.</p>
      </footer>
    </div>
  );
}
